export const REWARDS_HOME = {
  first: 20,
  initialNumToRender: 20,
  minimalGridMaxItems: 4,
  pageSize: 20,
  reachedThreshold: 2,
};
